import styled from "styled-components"

export const DocumentBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid #838383;
  padding: 16px;
  border-radius: 4px;
`;

export const DocumentMainInformations = styled.div`
  display: flex;
  gap: 42px;
  width: 100%;
  padding-bottom: ${(props) => props.isSignaturesExpanded ? "6px" : "0" };
  border-bottom: ${(props) => props.isSignaturesExpanded ? "1px solid #838383" : "none" }
`

export const DocumentBoxIdentifierContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 20%;
`;

export const DocumentName = styled.span`
  font-family: "Inter";
  font-size: 14px;
  font-weight: 500;
  color: #000000;
`;

export const DocumentSentAt = styled.span`
  font-family: "Inter";
  font-size: 12px;
  font-weight: 400;
  color: #1e1e1e;
`;

export const DocumentStatusContainer = styled.div`
  display: flex;
  min-width: 20%;
`;

export const DocumentStatusView = styled.span`
  font-family: "Inter";
  font-size: 14px;
  font-weight: 400;
  color: #1e1e1e;
  margin-left: 8px;
`

export const DocumentShowSignaturesContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

export const DocumentShowSignaturesToggle = styled.button`
  display: flex;
  justify-content: flex-end;
  background: transparent;
  gap: 8px;
  border: none;
  cursor: pointer;

  span {
    font-family: "Inter";
    font-size: 14px;
    font-weight: 400;
    color: #1e1e1e,
  }
`;
